import moment from 'moment'
moment.locale(`ru`)
export default {
  dateIsoToLocale: (str) => moment(str).format(`DD.MM.YYYY`),
  dateLocaleToIso: (str) => moment(str, `DD.MM.YYYY`).format(`YYYY-MM-DD`),
  datetimeIsoToLocale: (str) => moment(str, `YYYY-MM-DD HH:mm`).format(`DD.MM.YYYY HH:mm`),
  getDay: (str) => moment(str).format(`dd`),
  formatPhone: (str) => `+7 (${str.slice(2,5)}) ${str.slice(5,8)}-${str.slice(8,10)}-${str.slice(10-12)}`,
  cutPhone: (str) => str.replace(/[()\-\s]/g, ''),
  formatSum: (sum) => `${String(sum).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')}`,
  calcAge: (dateIso) => moment().diff(dateIso, 'years'),
  fioInitials: (str) => {
    const splited = str.split(` `)
    let res = `${splited[0]}`
    if(splited[1]) res += ` ${splited[1][0]}.`
    if(splited[2]) res += `${splited[2][0]}.`
    return res
  },
  formatTime: fullMinutes => {
    if (fullMinutes < 0) fullMinutes = 0;
    const hour = (Math.floor(fullMinutes / 60)).toString().padStart(2, '0'),
      minutes = (fullMinutes % 60).toString().padStart(2, '0');
    return `${hour}:${minutes}`;
  },
  getWeekDay: (date) => new Date(date).toLocaleString('ru-RU', { weekday: 'short' }),
}
